import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { withAreaGetter } from 'providers/AreasConsumers';
import GeneralEntityFlowEditContainer from './GenericEntityFlowEditContainer';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { entityContextRoutes } from 'constants/entityContexts';
import IconButton from 'components/common/buttons/IconButton';
import { entityContextVar } from './variables';
import PermissionCheck from 'components/common/PermissionCheck';
import { FlowPermissionType, useFlowPermissions } from './hooks';

const Route = ({ entityContext, getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();

  const handleClose = useCallback(() => {
    historyContext.push(`/${entityContextRoutes[entityContext]}`);
  }, [entityContext, historyContext]);

  const onRedirect = useCallback(
    genericEntityFlowId => {
      historyContext.push(`/${entityContextRoutes[entityContext]}/${genericEntityFlowId}`);
    },
    [entityContext, historyContext]
  );

  useEffect(() => {
    entityContextVar(entityContext);
    return () => {
      entityContextVar(null);
    };
  }, [entityContext]);

  return (
    <>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <IconButton type='backward' onClick={handleClose} size='medium' iconFontSize='medium' />
      </Portal>
      <PermissionCheck authorizationCode={useFlowPermissions(FlowPermissionType.READ)}>
        <GeneralEntityFlowEditContainer onRedirect={onRedirect} />
      </PermissionCheck>
    </>
  );
};

Route.propTypes = {
  entityContext: PropTypes.string.isRequired,
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
